import React from 'react';
import PropTypes from 'prop-types';

import deepFind from '../../utils/deepFind';

import { sanitizeString } from '../../utils/sanitizeString';

function processText(text, translationValues) {
  if (!translationValues) return text;

  const pattern = /{[a-zA-Z]+}/g;
  const result = text.replace(pattern, (match) => {
    const key = match.replace(/{|}/g, '');
    return translationValues[key];
  });

  return result;
}

export function getTranslation({ translationKey, translationValues, fallback }) {
  const map = window.translationMap || {};
  const translation = deepFind(map, translationKey || '');
  if (translation) {
    return processText(translation, translationValues);
  }

  return fallback || '';
}

const TranslationProvider = ({
  translationKey,
  translationValues,
  children,
  className,
}) => {
  const map = window.translationMap || {};

  let childElement = children;

  if (typeof childElement === 'string') {
    childElement = <p>{children}</p>;
  }

  const childText = childElement.props.children;
  const childProps = { ...childElement.props };
  delete childProps.children;

  const translation = deepFind(map, translationKey);
  let text = '';

  if (translation) {
    text = processText(translation, translationValues);
  } else if (childProps.dangerouslySetInnerHTML && childProps.dangerouslySetInnerHTML.__html) { // eslint-disable-line no-underscore-dangle
    text = childProps.dangerouslySetInnerHTML.__html.trim(); // eslint-disable-line no-underscore-dangle
  } else {
    text = childText;
  }
  const sanitizedText = sanitizeString(text);
  return React.createElement(
    childElement.type,
    {
      className,
      ...childProps,
      dangerouslySetInnerHTML: { __html: sanitizedText },
    }
  );
};

TranslationProvider.displayName = 'TranslationProvider';

TranslationProvider.propTypes = {
  translationKey: PropTypes.string.isRequired,
  translationValues: PropTypes.objectOf(PropTypes.string),
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  className: PropTypes.string,
};

TranslationProvider.defaultProps = {
  translationValues: undefined,
  className: '',
};

export default TranslationProvider;
